import React, { useEffect, useState } from "react";
import msgIcon02 from "../images/msg_icon_02.png";
import { apiWrapper } from "../apis/CommonApi";
import * as accountApi from "../apis/AccountApi";
import { useAppContext } from "../utils/store";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function WithdrawPage() {
  const {
    store: { userId },
  } = useAppContext();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("userId", "");
    setFormDataProperty("phoneNumber", "");
    setFormDataProperty("email", "");
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleSubmit = (e) => {
    if (window.confirm("정말로 탈퇴하시겠습니까?")) {
      e.preventDefault();

      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.stopPropagation();
      } else if (checkValid() === false) {
        e.stopPropagation();
      } else {
        apiWrapper(async () => {
          const { userId, phoneNumber, email } = formData;
          const { status, data } = await accountApi.deleteAccount(
            userId,
            phoneNumber,
            email
          );
          if (data) {
            alert(`${data}`);
          }
        });
      }
    }
  };

  const checkValid = () => {
    if (userId !== formData.userId) {
      alert("아이디를 확인해주세요.\n로그인한 아이디와 일치하지 않습니다.");
      return false;
    }

    return true;
  };

  return (
    <section class="mbSection MISection">
      <PageHeader isBlack={false} title="MY 계정" isUseMenu={false} />
      <form onSubmit={handleSubmit}>
        <div class="container pb-70">
          <div class="msgWrap">
            <img class="msg-icon" src={msgIcon02} alt="" />
            <p class="msg-title">
              정말로 <span class="bold red">회원탈퇴</span>하시겠습니까?
            </p>
            <div class="msg-detail-box">
              <p class="msg-cont">
                관련 법률에 따라, 회원님의 개인정보는 <br />
                <span class="bold">
                  탈퇴일로부터 30일 동안 보관
                </span>됩니다. <br />
                이후 법적 보관 기간이 만료되면 <br />
                모든 정보는 복구 불가능하게 삭제됩니다.
                <br />
                <br />
                다시 사용을 원하시면 회원가입을
                <br />
                다시 하셔야 합니다.
              </p>
            </div>
          </div>
          {formData && (
            <div class="input-wrap input-join-wrap">
              <div class="input-item">
                <p class="input-title">아이디</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="아이디를 입력해주세요."
                    name="userId"
                    value={formData.userId}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">휴대폰 번호</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="휴대폰 번호를 입력해주세요."
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">이메일</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="이메일을 입력해주세요."
                    name="email"
                    value={formData.email}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div class="btmBtnWrap">
          <button
            type="button"
            class="btn btn-black"
            onClick={() => navigate(-1)}
          >
            취소
          </button>
          <button type="submit" class="btn btn-grey">
            탈퇴
          </button>
        </div>
      </form>
    </section>
  );
}
